import * as tslib_1 from "tslib";
import { forkJoin, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { getOrigin, isSSR } from './util';
//import { getOrigin } from './util';
var CustomTranslateLoader = /** @class */ (function () {
    function CustomTranslateLoader(http, platformId) {
        this.http = http;
        this.isBrowser = false;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    CustomTranslateLoader.prototype.getTranslation = function (lang) {
        var s1 = isSSR() ? this.http.get(getOrigin() + "/assets/locales/" + lang + ".json") : of([]); // Le traduzioni delle rotte non servono per il prerendering
        var s2 = this.getMappone(lang);
        return forkJoin([s1, s2]).pipe(map(function (_a) {
            var _b = tslib_1.__read(_a, 2), traduzioniRotte = _b[0], mappa = _b[1];
            return (tslib_1.__assign({}, traduzioniRotte, mappa.traduzioni));
        }));
    };
    CustomTranslateLoader.prototype.getMappone = function (language) {
        var _this = this;
        if (this.isBrowser && sessionStorage.getItem('superServizio_' + language)) {
            return of(JSON.parse(sessionStorage.getItem('superServizio_' + language)));
        }
        else {
            return this.http.post(environment.apiUrl + 'sito/superServizio', { language: language }).pipe(map(function (res) {
                if (_this.isBrowser) {
                    sessionStorage.setItem('superServizio_' + language, JSON.stringify(res.result));
                }
                return res.result;
            }));
        }
    };
    return CustomTranslateLoader;
}());
export { CustomTranslateLoader };
